/* Evira presentation helpers. No cart, checkout, analytics or catalogue mutations. */
(() => {
  if (window.eviraPresentationLoaded) return;
  window.eviraPresentationLoaded = true;
  const responsive = window.matchMedia('(min-width: 990px)');
  const disclosures = new Set();
  let headerObserver;

  const selectProductSwatch = (button) => {
    const tile = button.closest('[data-product-tile]');
    if (!tile) return;

    tile.querySelectorAll('[data-product-swatch]').forEach((swatch) => {
      const selected = swatch === button;
      swatch.classList.toggle('is-active', selected);
      swatch.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });

    const variantUrl = button.dataset.variantUrl;
    if (variantUrl) {
      tile.querySelectorAll('[data-product-tile-link]').forEach((link) => {
        link.href = variantUrl;
      });
      const quickShop = tile.querySelector('[data-quick-shop]');
      if (quickShop) quickShop.dataset.quickShop = variantUrl;
    }

    const image = tile.querySelector('.product-tile__image--primary');
    const variantImage = button.dataset.variantImage;
    if (image && variantImage) {
      image.src = variantImage;
      image.removeAttribute('srcset');
      image.alt = button.dataset.variantImageAlt || image.alt;
      tile.classList.add('product-tile--swatch-selected');
    }

    const price = tile.querySelector('[data-product-tile-price]');
    if (price && button.dataset.variantPrice) {
      price.textContent = button.dataset.variantPrice;
    }

    const comparePrice = tile.querySelector('[data-product-tile-compare-price]');
    if (comparePrice && comparePrice.dataset.enabled === 'true') {
      const compareValue = button.dataset.variantComparePrice;
      comparePrice.textContent = compareValue || '';
      comparePrice.hidden = !compareValue;
    }
  };

  const initialiseProductSwatches = (root) => {
    root.querySelectorAll('[data-product-swatch]').forEach((button) => {
      if (button.dataset.eviraSwatchReady === 'true') return;
      button.dataset.eviraSwatchReady = 'true';
      button.addEventListener('click', (event) => {
        event.preventDefault();
        selectProductSwatch(button);
      });
    });
  };

  const initialise = (root) => {
    root.querySelectorAll('.rte p').forEach((paragraph) => {
      // Hide visual spacer paragraphs only; keep all text, media and the stored HTML intact.
      const isSpacer = !paragraph.textContent.replace(/[\s\u00a0\u200b-\u200f\ufeff]/g, '') &&
        !paragraph.querySelector('img, video, audio, iframe, svg, canvas, picture, object, embed, input, button, select, textarea, a, table');
      paragraph.classList.toggle('evira-empty-paragraph', isSpacer);
    });
    root.querySelectorAll('[data-evira-filters]').forEach((details) => {
      if (disclosures.has(details)) return;
      disclosures.add(details);
      details.open = responsive.matches || details.dataset.hasActiveFilters === 'true';
    });
    initialiseProductSwatches(root);
  };
  const trackHeader = () => {
    headerObserver?.disconnect();
    const header = document.querySelector('.header--sticky');
    if (!header || !window.ResizeObserver) return;
    const update = () => {
      document.documentElement.style.setProperty('--evira-header-height', `${Math.ceil(header.getBoundingClientRect().height)}px`);
      document.dispatchEvent(new Event('evira:header-resize'));
    };
    headerObserver = new ResizeObserver(update);
    headerObserver.observe(header);
    update();
  };
  responsive.addEventListener('change', () => disclosures.forEach((details) => {
    if (!details.isConnected) { disclosures.delete(details); return; }
    details.open = responsive.matches || details.dataset.hasActiveFilters === 'true';
  }));
  initialise(document);
  trackHeader();
  document.addEventListener('shopify:section:load', (event) => { initialise(event.target); trackHeader(); });
  document.addEventListener('shopify:section:unload', () => {
    disclosures.forEach((details) => { if (!details.isConnected) disclosures.delete(details); });
  });
})();
